import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { HttpClient, HttpContext } from '@angular/common/http';
import { ApiResponse, USE_ALL_SITES } from '@card-software/nexus-utilities';
import { ItemCategory } from '../../models/item-master';

@Injectable({
  providedIn: 'root',
})
export class ItemCategoryProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.itemApi + '/api/v1/item-category';

  public getAllItemsCategories(siteId?: string, useAllSites = false): Observable<ApiResponse<ItemCategory[]>> {
    const url = siteId ? `${this.baseUrl}/all?siteId=${encodeURIComponent(siteId)}` : `${this.baseUrl}/all`;
    const context = new HttpContext().set(USE_ALL_SITES, useAllSites);
    return this.httpClient.get<ApiResponse<ItemCategory[]>>(url, { context });
  }

  public createItemCategory(category: ItemCategory): Observable<ApiResponse<ItemCategory>> {
    return this.httpClient.post<ApiResponse<ItemCategory>>(this.baseUrl, category);
  }

  public updateItemCategory(id: string, fiberCategory: ItemCategory): Observable<ApiResponse<ItemCategory>> {
    return this.httpClient.put<ApiResponse<ItemCategory>>(`${this.baseUrl}/${id}`, fiberCategory);
  }

  public deleteFiberItemById(id: string): Observable<ApiResponse<void>> {
    return this.httpClient.delete<ApiResponse<void>>(`${this.baseUrl}/${id}`);
  }
}
